import React from 'react';
import { HStack, Button, Box } from '@medely/ui-kit';
import { useShiftSwapMutations } from './mutations';

export const JobDetailsSwapButtons = ({ id }: { id?: number | null }) => {
  const { declineSwapOffer, acceptSwapOffer } = useShiftSwapMutations();

  return (
    id && (
      <HStack gap={1}>
        <Box width="50%">
          <Button onClick={() => declineSwapOffer(id)} variant="outlined" fullWidth>
            Decline
          </Button>
        </Box>
        <Box width="50%">
          <Button onClick={() => acceptSwapOffer(id)} fullWidth>
            Accept
          </Button>
        </Box>
      </HStack>
    )
  );
};
